export const VIEW_DEBUG_LOGS = 'view_debug_logs'
export const MANAGE_USERS = 'manage_users'